import { gql } from '@apollo/client';

const AccountInfoShared = gql`
  fragment AccountInfoShared on Account {
    id
    accountNumber
    active
    nukable
    validCreditCard
    onboarded
    partnerLocation {
      id
      name
      isAllowedFreeTrial
      hasFreeTrialProduct
    }
    users {
      id
      firstName
      lastName
      email
      phone
      legacyId
    }
    accountAddresses {
      id
      address
      address2
      city
      region
      postalCode
      country
      isBilling
      isShipping
      isDefault
      accountId
    }
    patients {
      id
      firstName
      lastName
      legacyId
      arches
      dob
      birthDay
      birthMonth
      birthYear
      settingGroupOptionIds
      settingsOverride
      notes
      includeEot
      scanReady
      scanReadyAt
      scanSentAt
      sendToClinic
    }
    referrals {
      id
      hexCode
      state
      reminders
      consumedAt
      accountId
      patientAttributes {
        id
        includeEot
      }
      source
      sent
      sentAt
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
  }
`;

export default AccountInfoShared;
